/** Joins truthy class names with a space, skipping falsy values (undefined, false, ''). */
export function classNames(...values: (string | false | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}
